import * as React from 'react';

const SvgComponent = (props) => (
  <svg
    width={10}
    height={16}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M.95 15.242a1.346 1.346 0 0 1 0-1.902L4.77 9.51a2 2 0 0 0 0-2.825L.95 2.854A1.346 1.346 0 0 1 2.855.952l5.73 5.73a2 2 0 0 1 0 2.83l-5.73 5.73a1.346 1.346 0 0 1-1.904 0Z"
      fill="#424242"
    />
  </svg>
);

export default SvgComponent;
